	/* CUSTOM CODE */
  jQuery(document).ready(function($) {
  if (!$('body').hasClass('product_combo-product')) {
    if (!$('body').hasClass('product_mattress-deepdream')) {
    if($(window).width() >= 767){
    setTimeout(function(){
    // Get the two elements
      var productDescription = $('.product__description.rte');
      var productForm = $('.product-form');

      // Check if both elements exist and the description is above the form
      if (productDescription.length > 0 && productForm.length > 0 && productDescription.index() < productForm.index()) {
        // Insert productForm after productDescription
        productDescription.after(productForm);
      }
      }, 5000);
      
     //<---------------------------------------------------------- Reviews----------------------------------------------------------------------------------------->

           var ariaLabelElement = $(".jdgm-rev-widg__summary-stars");
if (ariaLabelElement.length > 0) {
    var ariaLabel = ariaLabelElement.attr("aria-label");
    if (ariaLabel) {
        // Extract the average rating from the aria-label and round to one decimal place
        var averageRating = parseFloat(ariaLabel.match(/(\d+\.\d+)/)[0]).toFixed(1);
        console.log("Average Rating:", averageRating);
    } else {
        console.log("aria-label attribute is missing.");
    }
} else {
    console.log("Element with class .jdgm-rev-widg__summary-stars not found.");
}
     // // Get the aria-label attribute value
     //  var ariaLabel = $(".jdgm-rev-widg__summary-stars").attr("aria-label");
     //  // Extract the average rating from the aria-label and round to one decimal place
     //  var averageRating = parseFloat(ariaLabel.match(/(\d+\.\d+)/)[0]).toFixed(1);
      // Use jQuery to find and extract the number from the HTML
      var basedOnText = $('.jdgm-rev-widg__header').find('.jdgm-rev-widg__summary-text').text();
      // var numberOfReviews = parseInt(basedOnText.match(/\d+/)[0]);
      var numberOfReviewsMatch = basedOnText.match(/\d+/);
      var numberOfReviews = numberOfReviewsMatch ? parseInt(numberOfReviewsMatch[0]) : 0;
      // Enclose numberOfReviews in parentheses
      var resultString = '(' + numberOfReviews + ')';   
      // Create a new element with the rounded rating
      var ratingElement = $("<span class='jdgm-prev-ratingp'>").text(averageRating + resultString);

      // Insert the new element after the element with class jdgm-prev-badge__stars
      if($(".jdgm-prev-badge__stars").length)  
      $(".jdgm-prev-badge__stars").after(ratingElement);
      //<---------------------------------------------------------- EndReviews----------------------------------------------------------------------------------------->
      //<---------------------------------------------------------- SaveLabel----------------------------------------------------------------------------------------->
    //   // Extract prices from the DOM
      var wasPriceText = $('.was__price i').text().trim();
      var wasPriceMatch = wasPriceText.match(/\d{1,3}(,\d{3})*\.\d{2}/);
      // console.log('############')   
      // console.log(wasPriceMatch)
      // console.log('############') 
        // Attempt to get wasPrice from .price__sale .price-item--regular if wasPriceMatch is null
      if (!wasPriceMatch) {
          wasPriceText = $('.price__sale .price-item--regular').text().trim();
          wasPriceMatch = wasPriceText.match(/\d{1,3}(,\d{3})*\.\d{2}/);
      }
      if (wasPriceMatch) {
        var wasPrice = parseFloat(wasPriceMatch[0].replace(',', ''));
        if($('.price--on-sale .price-item--regular').length){
          var salePrice = parseFloat($('.price--on-sale .price-item--regular').text().trim().match(/\d+\.\d{2}/)[0]);
        // console.log('############')   
        // console.log(wasPrice)
        // console.log(salePrice)
        // console.log('############') 
        // Calculate the percentage discount
        var percentageDiscount = ((wasPrice - salePrice) / wasPrice) * 100;

        // Format the discount message
        var discountMessage = 'Save ' + percentageDiscount.toFixed(0) + '%';

        // Append the discount message after .price-item--regular
        // $('.price__sale').after('<span class="savePercnt">' + discountMessage + '</span>');
          setTimeout(function(){
            if ($('.card-information').length > 0) {
              $('.card-information').each(function() {
                  const card = $(this);
                  
                  // Extract the sale price and original price
                  const salePrice = parseFloat(card.find('.price-item--sale').text().replace(/[^0-9.]/g, ''));
                  const originalPrice = parseFloat(card.find('s.price-item--regular').text().replace(/[^0-9.]/g, ''));
                  
                  // Calculate the discount percentage if both prices are available
                  if (originalPrice && salePrice && originalPrice > salePrice) {
                      const discountPercentage = ((originalPrice - salePrice) / originalPrice) * 100;
                      
                      // Display the discount percentage in the format "Save X%"
                      // card.find('.savePercnt').text(`Save ${discountPercentage.toFixed(0)}%`);
                  } else {
                      // If there's no discount, clear the text or show a default message
                      card.find('.savePercnt').remove();
                  }
              });
            }
          }, 1500)
        // console.log(wasPrice);
        }
        
      }

      // Event listener for radio buttons
      // $('.product-form__input input[type="radio"]').on('change', function() {
      //   setTimeout(function(){
      //     // Get selected size and color values
      //     var wasPriceText = $('.was__price i').text().trim();
      //     var wasPriceMatch = wasPriceText.match(/\d{1,3}(,\d{3})*\.\d{2}/);
      //     if (!wasPriceMatch) {
      //         wasPriceText = $('.price__sale .price-item--regular').text().trim();
      //         wasPriceMatch = wasPriceText.match(/\d{1,3}(,\d{3})*\.\d{2}/);
      //     }
      //     if (wasPriceMatch) {
      //     var wasPrice = parseFloat(wasPriceMatch[0].replace(',', ''));
      //     console.log(wasPrice);
    
      //     var salePrice = parseFloat($('.price__regular .price-item--regular').text().trim().match(/\d+\.\d{2}/)[0]);
    
      //     // Calculate the percentage discount
      //     var percentageDiscount = ((wasPrice - salePrice) / wasPrice) * 100;
    
      //     // Format the discount message
      //     var discountMessage = 'Save ' + percentageDiscount.toFixed(0) + '%';
    
      //     // Append the discount message after .price-item--regular
      //     $('.savePercnt').remove();  
      //     $('.price__sale').after('<span class="savePercnt">' + discountMessage + '</span>');
      //   } else {
      //     console.error("Price not found or not in the expected format");
      //   }
      //   }, 1000);
      // });

      //<---------------------------------------------------------- EndSaveLabel----------------------------------------------------------------------------------------->
      //<---------------------------------------------------------- PaymentLabel----------------------------------------------------------------------------------------->
      // Check if the element with class 'product_payement_logo_new' exists
    
      var paymentIconsContainer = $('.product_payement_logo_new');
      if (paymentIconsContainer.length > 0) {
        // Move the payment icons before .preorder_discout_bar
        $('.product-form__buttons').after(paymentIconsContainer);
      }
      var addToCartB = $('.product_detail_custom_add_to_cart')
      $('#ISR_button').before(addToCartB)
//       var addToCartB = $('.product_detail_custom_add_to_cart');
// $('#ISR_button').before('<div class="custom-cart-wrapper">Custom HTML Content</div>');
// $('#ISR_button').before(addToCartB);
      // $('.product_detail_custom_add_to_cart').after('<div id="ISR_button">Notify me when back in stock</div>');

      //<---------------------------------------------------------- EndPaymentLabel----------------------------------------------------------------------------------------->
     //<---------------------------------------------------------- DescriptionStarts----------------------------------------------------------------------------------------->
    
      var product__description = $('.product__description');

     if (product__description.length > 0) {
        // Move the payment icons before .preorder_discout_bar
        $('.post_check_main_grid').after(product__description);
      }
      // Get the existing description HTML
      var existingDescriptionHTML = $('.product__description.rte').html();

      // Create an accordion structure
      var accordionHTML = '<div class="accordion-item">' +
                         '<div class="accordion-title">Description</div>' +
                         '<div class="accordion-content">' +
                           existingDescriptionHTML +
                         '</div>' +
                       '</div>';

      // Replace the original description with the accordion structure
      $('.product__description.rte').html(accordionHTML);

      // Toggle accordion content on title click
      $('.accordion-title').on('click', function () {
        if (!$(this).hasClass('active')) {
            $('.accordion-title').removeClass('active');
            $('.accordion-content').slideUp();
    
            $(this).addClass('active').next('.accordion-content').slideDown();
        } else {
            $(this).removeClass('active').next('.accordion-content').slideUp();
        }
      });
     // Find the content in the .more-details div
      var moreDetailsContent = $(".more-details").html();

      // Check if there is content to move
      if (moreDetailsContent) {
          // Move the content to the .accordion-item .description
          $(".accordion-item .accordion-content").append(moreDetailsContent);

          // Remove the .more-details div
          $(".more-details").remove();
      }
     //<---------------------------------------------------------- EndDescriptionStarts----------------------------------------------------------------------------------------->
     //<---------------------------------------------------------- DimentionsTitle----------------------------------------------------------------------------------------->
     // Create a new h3 element with the specified class and text
      var dimensionsHeader = $("<h3 class='text-center'>Dimensions</h3>");

      // Insert the new element before the element with class .desktop_dimension
      dimensionsHeader.insertBefore(".desktop_dimension");
    //<---------------------------------------------------------- EndDescription----------------------------------------------------------------------------------------->
     //<---------------------------------------------------------- preOrderDiscountBar----------------------------------------------------------------------------------------->
     // Check if .preorder_discout_bar is present
      var preorderDiscountBar = $('.preorder_discout_bar');

      if (preorderDiscountBar.length > 0) {
          // Move .preorder_discout_bar before .product_detail_custom_add_to_cart
          preorderDiscountBar.insertBefore('.product_detail_custom_add_to_cart');
      }
     //<---------------------------------------------------------- preOrderDiscountBarEnd----------------------------------------------------------------------------------------->
     if ($(window).width() < 960) {
       $('.product__info-wrapper.grid__item').before('<div class="trust-elements"><span>80,000+ Happy Customers</span><span>Express Shipping</span><span>Easy Returns</span></div>');
       console.log('asdasdasdasddddddddddddddddddddddddddddddddddddd');
    }
    }
    
    }else{
      console.log(2222222222222222222222222222222222)
      // $('.post_check_main_grid').insertAfter($('.post_check_main_grid').next('div'));
      var paymentIconsContainer = $('.product_payement_logo_new');
      if (paymentIconsContainer.length > 0) {
        // Move the payment icons before .preorder_discout_bar
        $('.product-form__buttons').after(paymentIconsContainer);
      }
    }
  }
   });
	
